import { render } from "./ApplicationFormRegular.vue?vue&type=template&id=8cbbbf18&scoped=true"
import script from "./ApplicationFormRegular.vue?vue&type=script&lang=js"
export * from "./ApplicationFormRegular.vue?vue&type=script&lang=js"

import "./ApplicationFormRegular.vue?vue&type=style&index=0&id=8cbbbf18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbbbf18"]])

export default __exports__